import React from "react";

interface CircularScoreProps {
  label: string;
  value: number;
  color?: string;
}

export const CircularScore: React.FC<CircularScoreProps> = ({ 
  label, 
  value, 
  color = "blue" 
}) => {
  const percentage = Math.round(value);
  const circumference = 2 * Math.PI * 20; // radius = 20
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const colorClasses = {
    blue: "stroke-blue-600",
    green: "stroke-green-600",
    indigo: "stroke-indigo-600",
  };

  return (
    <div className="flex items-center gap-2">
      <div className="relative w-12 h-12">
        <svg className="transform -rotate-90 w-12 h-12">
          {/* Background circle */}
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
            className="text-gray-200"
          />
          {/* Progress circle */}
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className={colorClasses[color as keyof typeof colorClasses] || colorClasses.blue}
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-semibold">{percentage}%</span>
        </div>
      </div>
      <div>
        <p className="text-sm font-medium text-gray-700">{label}</p>
        <p className="text-xs text-gray-500">{percentage}%</p>
      </div>
    </div>
  );
};

